module.exports = __webpack_public_path__ + "static/media/Segoe.0e7e9a9b.ttf";